var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgPlayerB5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 145,
    viewBox: "0 0 100 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2584 23.125L46.6029 20L51.0526 21.3393L58.1722 27.1429L60.8421 28.0357H65.2919L66.6268 29.375L65.2919 31.6071L63.9569 32.9464L65.2919 36.0714L66.1818 36.9643L100 48.125V51.6964L66.6268 45L65.7368 45.8929V51.25L65.2919 55.7143L66.1818 58.3929L75.9713 62.8571L85.7608 68.2143L91.9904 74.4643L93.7703 73.5714L100 72.2321V94.9821L91.9904 99H85.7608L78.1962 107.946L75.9713 120.893L72.4115 133.393V145H7L7.88995 122.232L13.6746 103.929L21.6842 82.9464L31.4737 65.0893L36.3684 59.2857L37.2584 56.1607L35.0335 53.4821L32.3636 50.3571L31.4737 48.125L28.8038 43.6607L28.3589 35.1786L31.4737 28.0357L37.2584 23.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPlayerB5);
export default __webpack_public_path__ + "static/media/bg_player_b5.d2a4c541e685cfd1f1397f041516cccc.svg";
export { ForwardRef as ReactComponent };